import Sortable from "sortablejs/modular/sortable.core.esm.js"
import { reorderTqasMutation } from "../utils/reorder_tqas"

export default function actionsSortable(serviceSlug) {
  function reorderActions() {
    let actionIds = []
    document.querySelectorAll(".input-list li").forEach(actions => {
      actionIds.push(actions.dataset["actionId"])
    })

    reorderTqasMutation(serviceSlug, "action", actionIds)
      .then(() => {
        App.Scripts.partners.displayFlash("Actions reordered")
      })
      .catch(() => {
        App.Scripts.partners.displayFlash("There has been an error reordering the Actions, try again!", "error")
      })
  }

  const inputsEl = document.getElementById("input-list")
  return Sortable.create(inputsEl, {
    animation: 150,
    onUpdate: reorderActions,
  })
}
